// extracted by mini-css-extract-plugin
module.exports = {"deleteModal":"_2G_Ai","checkbox":"A-rDu","okButton":"_1Cgwq","modalText":"_1TP3O","content":"_3CfEy","dot":"_3yJtD"};